import React, { useRef } from "react";
import "./textInput.css";

function TextInput(props) {
  const input = useRef(null);
  const onChange = props.onChange || (() => {});

  return (
    <span className="textInput-clear">
      <input
        ref={input}
        onChange={e => onChange(e.target.value)}
        value={props.value}
        type="text"
        {...props.attrs}
      />
      {props.value ? (
        <span onClick={() => onChange("") || input.current.focus()}>
          &times;
        </span>
      ) : null}
    </span>
  );
}

export default TextInput;
